var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buy-money-box" }, [
    _c("div", {
      ref: "echartsPie",
      staticClass: "echarts-pie",
      attrs: { id: "echarts-pie" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }